let config = {
  title: "卫健认证全网经办系统",
  homeTitle: "卫健认证全网经办系统",
  contendTitle: "卫健认证全网经办系统",
  homeBackground: require("../../assets/ch.png")
};
let Host = window.location.host;
if (Host == "manager.minzhengju.com") {
  config.title = "民政认证全网经办系统";
  config.homeTitle = "民政认证全网经办系统";
  config.contendTitle = "民政认证全网经办系统";
} else if (Host == "manager.weijianwei.top") {
  config.title = "卫健认证全网经办系统";
  config.homeTitle = "卫健认证全网经办系统";
  config.contendTitle = "卫健认证全网经办系统";
} else if (Host == "liaocheng.rensheju.com") {
  config.title = "聊城企保全网经办系统";
  config.homeTitle = "聊城企保全网经办系统";
  config.contendTitle = "聊城企保全网经办系统";
} else if (Host == "junrenju.weface.com.cn") {
  config.title = "军人事务全网经办系统";
  config.homeTitle = "军人事务全网经办系统";
  config.contendTitle = "军人事务全网经办系统";
}else if (Host == "dyhy.rensheju.com") {
  config.title = "待遇领取认证核验系统";
  config.homeTitle = "待遇领取认证核验系统";
  config.contendTitle = "待遇领取认证核验系统";
}
else if (Host == "yanggu.rensheju.com") {
  config.title = "待遇领取认证核验系统";
  config.homeTitle = "待遇领取认证核验系统";
  config.contendTitle = "待遇领取认证核验系统";
}

export { config };



// WEBPACK FOOTER //
// ./src/utils/config/urlConfig.js